import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";   // ✅ ADD THIS

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>                      {/* ✅ Wrap your whole app */}
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </HelmetProvider>
);

reportWebVitals();
